import { useState, useRef, useEffect } from 'react'
import { FaRegEdit } from 'react-icons/fa'
import { IoClose } from "react-icons/io5";
import { ConvertPriceToString } from '../../../Helpers/CustomConverter';
import { useAuth } from '../../../Providers/AuthProvider';
import { handleInputKeyPressForQtyAndValueInput, handleInputForQtyAndValueFocus, handleOnChangeForQtyAndValueInput, handleInputForQtyAndValueLostFocus } from '../../../Helpers/PriceAndValueInputHelpers';
import useGetProductIndexWithMask from '../../../Components/BasketPage/Hooks/useGetProductIndexWithMask';
import useCheckPrice from '../Hooks/useCheckPrice';
import LoadingSpinner from '../../../Components/Components/LoadingSpinner';
import { toast } from 'react-toastify';
import { FaCheck } from "react-icons/fa6";
import { useParams } from '../../../Providers/ParamsProvider.jsx';
import { getIndeksHeader } from '../../../Helpers/ValidatorHelper.jsx';

const OfferRequestItemsTable = ({ products, setProducts, handleRemoveProduct, handleUpdateSavedOfferAfterEdit, cartTotalNet, cartTotalGross }) => {
    const { authState } = useAuth()
    const { license, isMobile } = useParams()
    let isPh = authState.user && authState.user.isOperator ? true : false

    if (!products || products.length === 0) {
        return <span className='error-text-color '>Brak produktów, dodaj pozycję do koszyka i wróć do tego okna.</span>
    }
    return (
        <div className='table-responsive'>
            <table className={`${isMobile ? 'table-font-small' : ''} table table-bordered`}>
                <thead>
                    <tr className='border-bottom border-top'>
                        <th style={{ width: "5%" }}>LP</th>
                        <th style={{ width: "10%" }}>{getIndeksHeader(license)}</th>
                        <th style={{ width: "auto" }}>NAZWA CECHA</th>
                        <th style={{ width: "12%" }}>CENA NETTO PLN</th>
                        {isPh && <th style={{ width: '7%' }}>RABAT %</th>}
                        <th style={{ width: "5%" }}>ILOŚĆ</th>
                        <th style={{ width: "13%" }}>SUMA NETTO PLN SUMA BRUTTO PLN</th>
                        <th style={{ width: "5%" }}></th>
                        <th style={{ width: "5%" }}></th>
                    </tr>
                </thead>
                <tbody>
                    {products.map((x, key) => (
                        <ProductsTableContent
                            lp={key}
                            key={key}
                            basketItem={x}
                            handleRemoveProduct={handleRemoveProduct}
                            setProducts={setProducts}
                            handleUpdateSavedOfferAfterEdit={handleUpdateSavedOfferAfterEdit}
                            isPh={isPh}
                            authState={authState}
                        />
                    ))}
                    <TableDataSummary
                        basketItems={products}
                        isPh={isPh}
                        cartTotalNet={cartTotalNet}
                        cartTotalGross={cartTotalGross}
                    />
                </tbody>
            </table>
        </div>
    )
}

const ProductsTableContent = ({ basketItem, lp, handleRemoveProduct, setProducts, handleUpdateSavedOfferAfterEdit, isPh, authState }) => {
    const [initialCostNet, setInitialCostNet] = useState(basketItem.costNet)
    const [initialCostGross, setInitialCostGross] = useState(basketItem.costGross)
    const [initialQty, setInitialQty] = useState(basketItem.qty)

    const { handleCheckMinimumPrice } = useCheckPrice()
    const { getProductIndexWithMask } = useGetProductIndexWithMask()
    const [isEditMode, setIsEditMode] = useState(false)
    const inputRef = useRef(null)
    const decimalPlaces = basketItem.product.decimalPlaces
    const [isPriceCheckingProgress, setIsPriceCheckingProgress] = useState(false)
    const [isPriceConfirmed, setIsPriceConfirmed] = useState(true)
    const [discountPercent, setDiscountPercent] = useState(parseFloat(((basketItem.product.priceNetBase - basketItem.costNet) / basketItem.product.priceNetBase) * 100).toFixed(2))
    const [initialDiscount, setInitialDiscount] = useState(isNaN(discountPercent) ? 0 : parseFloat(discountPercent).toFixed(2))

    const handleInputKeyDown = (e, decimalPlacesParam) => {
        const tmpDecimalPlaces = decimalPlacesParam ? decimalPlacesParam : decimalPlaces
        if (!handleInputKeyPressForQtyAndValueInput(e, tmpDecimalPlaces)) {
            e.preventDefault()
            return
        }
    }

    const handleInputOnChange = (e) => {
        if (!handleOnChangeForQtyAndValueInput(e, decimalPlaces)) {
            e.preventDefault()
            return
        }
        setProducts(prevProducts =>
            prevProducts.map(item =>
                item.product.index === basketItem.product.index ? { ...item, qty: parseFloat(e.target.value) } : item
            )
        )

    }

    const handlePriceInputChange = (e) => {
        if (!handleOnChangeForQtyAndValueInput(e, 2)) {
            e.preventDefault()
            return
        }
        setProducts(prevProducts =>
            prevProducts.map(item => {
                if (item.product.index === basketItem.product.index) {
                    const newCostNet = parseFloat(e.target.value)
                    const newCostGross = parseFloat(newCostNet * (1 + basketItem.product.taxRate / 100))
                    const discountPercent = parseFloat(((basketItem.product.priceNetBase - newCostNet) / basketItem.product.priceNetBase) * 100).toFixed(2)
                    setDiscountPercent(discountPercent)
                    return {
                        ...item,
                        costNet: newCostNet,
                        costGross: newCostGross,
                        isPriceConfirmed: false
                    }
                }
                return item
            }))
    }

    /**
     * DK : Funkcja po lost focus zmainy ceny lub marży
     * @param {*} e 
     * @param {*} priceNet Cena netto gdy zmieniamy marże, inaczej cena netto pobierana jest z e.target.value
     */
    const handlePriceInputOnBlur = async (e, priceNet) => {
        handleInputForQtyAndValueLostFocus(e, 2)
        //setIsPriceCheckingProgress(true)
        let tmpPriceNet = priceNet ? priceNet : e.target.value
        const checkPriceResult = await handleCheckMinimumPrice(authState.custId, basketItem.product.index, tmpPriceNet)
        if (checkPriceResult) {
            //setIsPriceConfirmed(true)
            setProducts(prevProducts =>
                prevProducts.map(item => {
                    if (item.product.index === basketItem.product.index) {
                        return { ...item, isPriceConfirmed: true }
                    }
                    return item
                }))
        }
        else {
            //setIsPriceConfirmed(false)
            setProducts(prevProducts =>
                prevProducts.map(item => {
                    if (item.product.index === basketItem.product.index) {
                        return { ...item, isPriceConfirmed: false }
                    }
                    return item
                }))
        }
        //setIsPriceCheckingProgress(false)
    }

    const handleChangeEditMode = async (itemQty, costNet, taxRate) => {
        if (isEditMode) { //po wyjściu e zdycji
            if (isNaN(itemQty)) {
                toast.warning('Prosze uzupełnić pole ilość!')
                return
            }
            if (isPh) {
                const checkPriceResult = await handleCheckMinimumPrice(authState.custId, basketItem.product.index, costNet)
                if (!checkPriceResult) {
                    toast.warning('Cena produktu poniżej dopuszczalnej marży minimalnej!')
                    return
                }
            }
            setNewInitialValues(costNet, taxRate, itemQty)
            handleUpdateSavedOfferAfterEdit()
        }
        setIsEditMode(prev => !prev)

    }

    /**
     * //DK : Nadpisujemy init value po zatwierdzeniu ptaszkiem by do tego cofnąć X
     * @param {*} costNet 
     * @param {*} taxRate 
     * @param {*} itemQty 
     */
    const setNewInitialValues = (costNet, taxRate, itemQty) => {
        setInitialCostNet(costNet)
        setInitialCostGross(parseFloat(costNet * (1 + taxRate / 100)))
        setInitialQty(itemQty)
        setInitialDiscount(discountPercent)
    }

    const handleRemoveProductInternalFunc = (e, index) => {
        if (isEditMode) {
            e.preventDefault()
            setIsEditMode(false)
            setProducts(prev =>
                prev.map(item =>
                    item.product.index === index
                        ? {
                            ...item,
                            costNet: initialCostNet,
                            costGross: initialCostGross,
                            qty: initialQty,
                            isPriceConfirmed: true,
                        }
                        : item
                ))
            setIsPriceConfirmed(true)
            setDiscountPercent(initialDiscount)
            return
        }
        else {
            handleRemoveProduct(index)
        }
    }

    let priceBorderStyle = isPriceConfirmed ? 'offer-price-confirmed' : 'offer-price-not-confirmed'

    useEffect(() => {
        const checkPriceAfterTyping = async () => {
            const checkPriceResult = await handleCheckMinimumPrice(authState.custId, basketItem.product.index, basketItem.costNet)
            if (checkPriceResult) {
                setIsPriceConfirmed(true)
            }
            else {
                setIsPriceConfirmed(false)
            }
        }

        checkPriceAfterTyping()
    }, [basketItem.costNet])

    return (
        <tr>
            <td>{lp + 1}</td>
            <td>{getProductIndexWithMask(basketItem.product.index)}</td>
            <td>{basketItem.product.title + basketItem.product.label}</td>

            {isPriceCheckingProgress ? (<LoadingSpinner width={1.5} height={1.5} />) : (<>{isEditMode && isPh ?
                (<td style={{ textAlign: 'right' }}>
                    <input type='number' value={basketItem.costNet} className={`biggerArrows offer-request-input ${priceBorderStyle}`} style={{ width: '100px' }}
                        step={Math.pow(10, -2)} onFocus={handleInputForQtyAndValueFocus} min={0} max={999999} onChange={handlePriceInputChange}
                        onKeyDown={(e) => handleInputKeyDown(e, 2)} onBlur={(e) => handlePriceInputOnBlur(e)} />
                </td>)
                : (<td style={{ textAlign: 'right' }}>{ConvertPriceToString(basketItem.costNet, null)}</td>)}</>)}

            <DiscountPercentComponent
                isPh={isPh}
                isEditMode={isEditMode}
                discountPercent={discountPercent}
                costNet={basketItem.costNet}
                handlePriceInputOnBlur={handlePriceInputOnBlur}
                setProducts={setProducts}
                setDiscountPercent={setDiscountPercent}
                basketItem={basketItem}
            />

            {isEditMode ? (<td style={{ textAlign: 'right' }}>
                <input type='number' value={basketItem.qty} min={0} max={999999} className='biggerArrows offer-request-input' style={{ width: '100px' }} step={Math.pow(10, -decimalPlaces)} ref={inputRef}
                    onFocus={handleInputForQtyAndValueFocus} onKeyDown={(e) => handleInputKeyDown(e, decimalPlaces)} onChange={handleInputOnChange} onBlur={(e) => handleInputForQtyAndValueLostFocus(e, decimalPlaces)} />
            </td>) : (<td style={{ textAlign: 'right' }}>{isNaN(basketItem.qty) ? 0 : basketItem.qty}</td>)}

            <td style={{ textAlign: 'right' }}>
                <div className='d-flex flex-column'>
                    <b>{ConvertPriceToString(((isNaN(basketItem.costNet) ? 0 : basketItem.costNet) * basketItem.qty), null)}</b>
                    <span>{ConvertPriceToString((isNaN(basketItem.costGross) ? 0 : basketItem.costGross) * basketItem.qty, null)}</span>
                </div>
            </td>
            <td>
                {isEditMode ? (<FaCheck cursor={'pointer'} size={25} onClick={() => handleChangeEditMode(basketItem.qty, basketItem.costNet, basketItem.product.taxRate)} color='var(--success-color)' />) :
                    (<FaRegEdit cursor={'pointer'} size={25} onClick={() => handleChangeEditMode(basketItem.qty, basketItem.costNet, basketItem.product.taxRate)} />)}
            </td>
            <td><IoClose cursor={'pointer'} size={25} onClick={(e) => handleRemoveProductInternalFunc(e, basketItem.product.index)} color='var(--error-color)' /></td>
        </tr>
    )
}

const DiscountPercentComponent = ({ isPh, isEditMode, discountPercent, costNet, handlePriceInputOnBlur, setProducts, setDiscountPercent, basketItem }) => {

    const handleDiscountPercentChange = (e) => {
        if (!handleOnChangeForQtyAndValueInput(e, 2)) {
            e.preventDefault()
            return
        }
        const value = e.target.value
        const number = parseFloat(value.replace(',', '.'))
        const regex = /^-?\d{0,2}([.,]\d{0,2})?$/

        if (regex.test(value) && number >= -99.99 && number <= 99.99 || isNaN(number)) {
            const newDiscount = isNaN(parseFloat(value)) ? 0 : parseFloat(value)
            setProducts(prev =>
                prev.map(item => {
                    if (item.product.index === basketItem.product.index) {
                        const newCostNet = item.product.priceNetBase * (1 - newDiscount / 100)
                        const newCostGross = newCostNet * (1 + item.product.taxRate / 100)
                        return {
                            ...item,
                            costNet: newCostNet.toFixed(2),
                            costGross: newCostGross.toFixed(2),
                            isPriceConfirmed: false
                        }
                    }
                    return item
                })
            )
            setDiscountPercent(value)
        }
        else {
            e.preventDefault()
        }
    }

    if (!isPh) {
        return null
    }
    if (isEditMode) {
        return (<td style={{ textAlign: 'right' }}>
            <input type='number' value={discountPercent} className='biggerArrows offer-request-input' max={99} min={-99} onBlur={(e) => handlePriceInputOnBlur(e, costNet)}
                style={{ width: '100px' }} onFocus={handleInputForQtyAndValueFocus} onChange={handleDiscountPercentChange}
            />
        </td>)
    }
    else {
        return <td style={{ textAlign: 'right' }}>{isNaN(discountPercent) ? `0` : `${parseFloat(discountPercent).toFixed(1)}`}</td>
    }
}

const TableDataSummary = ({ basketItems, isPh, cartTotalNet, cartTotalGross }) => {
    const totalQty = basketItems.reduce((acc, item) => acc + (isNaN(item.qty) ? 0 : item.qty), 0)

    return (
        <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            {isPh && <td></td>}
            <td style={{ textAlign: 'right' }}>{totalQty}</td>
            <td style={{ textAlign: 'right' }}>
                <div className='d-flex flex-column'>
                    <b>{ConvertPriceToString(cartTotalNet, null)}</b>
                    <span>{ConvertPriceToString(cartTotalGross, null)}</span>
                </div>
            </td>
            <td></td>
            <td></td>
        </tr>
    )
}

export default OfferRequestItemsTable